"use client";

import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type ReactNode, createContext, use, useReducer } from "react";
import { type CommentsState, type PaginationState, commentsReducer } from "@/components/Comment/reducer/comment-reducer";
import type { CommentsAction } from "@/components/Comment/reducer/comment-reducer.types";
import type { CommentModel } from "@/services/api/comment/models/comment.model.types";
type CommentsContextValue = {
  readonly state: CommentsState;
  readonly dispatch: Dispatch<CommentsAction>;
  readonly storyId: string;
  readonly hasActiveSubscription: boolean;
  readonly hasValidUserName: boolean;
  readonly isLoggedIn: boolean;
  readonly isClosed: boolean;
};
const CommentsContext = createContext<CommentsContextValue | null>(null);
export function useComments(): CommentsContextValue {
  const context = use(CommentsContext);
  if (!context) {
    throw new Error("useComments must be used within CommentsProvider");
  }
  return context;
}
type CommentsProviderProps = {
  readonly children: ReactNode;
  readonly hasActiveSubscription: boolean;
  readonly hasValidUserName: boolean;
  readonly initialComments: ReadonlyArray<CommentModel>;
  readonly initialCommentsCount: number;
  readonly initialPagination?: PaginationState;
  readonly isClosed: boolean;
  readonly isLoggedIn: boolean;
  readonly storyId: string;
};
const defaultPagination: PaginationState = {
  endCursor: null,
  hasNextPage: false
};
export function CommentsProvider(t0) {
  const $ = _c(14);
  const {
    children,
    hasActiveSubscription,
    hasValidUserName,
    initialComments,
    initialCommentsCount,
    initialPagination: t1,
    isClosed,
    isLoggedIn,
    storyId
  } = t0;
  const initialPagination = t1 === undefined ? defaultPagination : t1;
  let t2;
  if ($[0] !== initialComments || $[1] !== initialCommentsCount || $[2] !== initialPagination) {
    t2 = {
      comments: initialComments,
      isModalOpen: false,
      pagination: initialPagination,
      totalComments: initialCommentsCount
    };
    $[0] = initialComments;
    $[1] = initialCommentsCount;
    $[2] = initialPagination;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [state, dispatch] = useReducer(commentsReducer, t2);
  let t3;
  if ($[4] !== hasActiveSubscription || $[5] !== hasValidUserName || $[6] !== isClosed || $[7] !== isLoggedIn || $[8] !== state || $[9] !== storyId) {
    t3 = {
      dispatch,
      hasActiveSubscription,
      hasValidUserName,
      isClosed,
      isLoggedIn,
      state,
      storyId
    };
    $[4] = hasActiveSubscription;
    $[5] = hasValidUserName;
    $[6] = isClosed;
    $[7] = isLoggedIn;
    $[8] = state;
    $[9] = storyId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const value = t3;
  let t4;
  if ($[11] !== children || $[12] !== value) {
    t4 = <CommentsContext value={value}>{children}</CommentsContext>;
    $[11] = children;
    $[12] = value;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}